import { isClerkAuthEnabled } from '@/utils/auth/authMode';

import ClerkSignInPage from './ClerkSignInPage';
import CognitoSignInPage from './CognitoSignInPage';

const SignInPage = () => {
  if (isClerkAuthEnabled()) {
    return <ClerkSignInPage />;
  }
  return <CognitoSignInPage />;
};

export default SignInPage;
